<template>
    <div class="non-exist-box-container">
     
         <img class="non-exist-icon" src="/icons/general_icons/non-exist-icon.png" alt="non.exist.icon">
 
     
     <p class="messages"> {{ responseStatusMessages }} </p> 
    </div>
 
 </template>
 
 <script>
 export default {
 props:{
   responseStatusMessages:{
       type:String,
       default:''
   }
 }
 }
 </script>
 
 <style scoped lang="scss">
 
 .non-exist-box-container {
     width: 100%;
     height: 100%;
     display: flex;
     flex-flow: row;
     align-items: center;
     justify-content: center;
     padding: 1vw;
     gap: 3%;
     border: 1px dotted #e91414d8;
     border-radius: 8px;

 
 }
 
 .non-exist-icon {
height: 2vw;
 width: 2vw;
 
 
 }
 
 .messages {
    width: max-content;
     font-size: .7vw;
     font-weight: 550;
     color: #0d0f27b9;
 }
 </style>